// extracted by mini-css-extract-plugin
export default {"select":"FormItems_select__ulqgk","formItem":"FormItems_formItem__6mMeJ"};